import { v4 as uuidv4 } from 'uuid';

export function getDefault() {
  const userAgent = navigator.userAgent.toLowerCase();
  let operatingSystem = 'Other';

  // Mobile devices
  if (/iphone|ipad|ipod/.test(userAgent)) {
    operatingSystem = 'iOS';
  } else if (/android/.test(userAgent)) {
    operatingSystem = 'Android';
  }

  let sessionId = sessionStorage.getItem('cjm_session_id');
  if (!sessionId) {
    sessionId = uuidv4();
    sessionStorage.setItem('cjm_session_id', sessionId);
  }

  return {
    appVersion: navigator.userAgent,
    operatingSystem: operatingSystem,
    networkType: navigator?.connection?.type || null,
    userId: localStorage.getItem('ldp_token'),
    sessionId: sessionId,
    phoneNumberValue: localStorage.getItem('ldp_msisdn'),
    providerType: null,
    timeStamp: String(Date.now()),
  };
}

export function cjmOnUserLogin(identity, phone) {
  if(window.cjm?.onUserLogin?.push) {
    window.cjm.onUserLogin.push({
      "Site": {
        "Identity": identity,
        "Phone": phone
      }
    });
      setTimeout(() => {
        if (window.cjm.getCjmID) {
          console.log("getCjmID: ", window.cjm.getCjmID());
        }
      }, 100);
  }
}

export function cjmEventScreenDisplayed(partnerName = "myvnpt_web", screenName, packageName) {
  if(window.cjm?.event?.push) {
    window.cjm.event.push("service_screen_displayed", {
      ...getDefault(),
      "partnerName": partnerName,
      "screenName": screenName,
      "packageName": packageName
    });
  }
}

export function cjmEventComponentDisplayed(partnerName = "myvnpt_web", screenName, componentName, componentValue) {
  if(window.cjm?.event?.push) {
    window.cjm.event.push("service_component_displayed", {
      ...getDefault(),
      "partnerName": partnerName,
      "screenName": screenName,
      "componentName": componentName,
      "componentValue": componentValue
    });
  }
}

export function cjmEventButtonClicked(partnerName = "myvnpt_web", screenName, buttonName) {
  if(window.cjm?.event?.push) {
    window.cjm.event.push("service_button_clicked", {
      ...getDefault(),
      "partnerName": partnerName,
      "screenName": screenName,
      "buttonName": buttonName,
    });
  }
}

export function cjmEventBlockClicked(partnerName = "myvnpt_web", screenName, blockType, blockName) {
  if(window.cjm?.event?.push) {
    window.cjm.event.push("service_block_clicked", {
      ...getDefault(),
      "partnerName": partnerName,
      "screenName": screenName,
      "blockType": blockType,
      "blockName": blockName,
    });
  }
}

export function cjmEventIconClicked(partnerName = "myvnpt_web", screenName, iconName) {
  if(window.cjm?.event?.push) {
    window.cjm.event.push("service_icon_clicked", {
      ...getDefault(),
      "partnerName": partnerName,
      "screenName": screenName,
      "iconName": iconName,
    });
  }
}

export function cjmEventItemSelected(partnerName = "myvnpt_web", screenName, listName, itemValue) {
  if(window.cjm?.event?.push) {
    window.cjm.event.push("service_item_selected", {
      ...getDefault(),
      "partnerName": partnerName,
      "screenName": screenName,
      "listName": listName,
      "itemValue": itemValue,
    });
  }
}